export interface PostFnolInitPayload {
  context: PostFnolContext;
  claimNumber: string;
  policyNumber: string;
  customerId: string;
  userId: string;
  name: string;
  exposureId: string;
  vin: string;
  emailAddress: string;
  garageZipcode: string;
}

export enum PostFnolContext {
  MY_ACCOUNT,
  THIRD_PARTY
}
